import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import {Button} from "../../../components";
import AuthLayout from "../../../layouts/AuthLayout";
import {
  AUTH_BODY_CLASS as BODY_CLASS,
  AUTH_CONTENT_CLASS,
  AUTH_HEADING_CLASS as HEADING_CLASS,
} from "../auth-screen.classes";
import {formatDuration} from "../../../utils/helpers";
import {AuthService, ToastService} from "../../../services";

const ConfirmEmail = () => {
  const [seconds, setSeconds] = useState(300);
  const { uuid } = useParams<{ uuid: string }>();

  useEffect(() => {
    if (seconds <= 0)
      return;

    const timer = setTimeout(() => {
      setSeconds(seconds - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [seconds]);

  const onResendEmail = () => {
    AuthService.resendVerifyEmail(uuid).then(() => {
      setSeconds(300);
      ToastService.success(<><span className="text-success mr-1">Successfully</span> sent your request.</>);
    }).catch((err) => {
      ToastService.showHttpError(err, 'Resending email failed');
    });
  };

  return (
    <AuthLayout contentClass={AUTH_CONTENT_CLASS}>
      <div className="w-full flex flex-col justify-between">
        <h1 className={HEADING_CLASS}>Almost done!</h1>

        <p className={BODY_CLASS}>An activation email has been sent to your account.</p>

        <p className="text-white text-sm mt-8">Please <span className="font-semibold">click on the link</span> in your email to continue signing up.</p>

        <p className="text-white text-sm mt-4">If you <span className="font-semibold">haven&apos;t received</span> the email, <span className="font-semibold">check your SPAM</span> folder or try resending the email in 5 minutes.</p>

        <div className="text-white text-4xl font-semibold mt-4">{formatDuration(seconds, 'm:ss')}</div>

        <Button color="primary" className="w-full rounded-full shadow-md mt-8" onClick={onResendEmail}>
          Resend code
        </Button>
      </div>
    </AuthLayout>
  );
};

export default ConfirmEmail;
